var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.highlights.length > 0
    ? _c(
        "section",
        { staticClass: "feature-highlights" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass: "highlights",
                        class: `${_vm.highlightsLayoutClass}`,
                      },
                      _vm._l(_vm.highlights, function (highlightItem, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "highlight-item" },
                          [
                            _c(_vm.getLayoutComponent, {
                              tag: "component",
                              attrs: { highlight: highlightItem },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }